export default "__VITE_ASSET__1b4e3166__"